import { render, staticRenderFns } from "./TimesheetTradieWeekBlock.vue?vue&type=template&id=52a2d194&scoped=true"
import script from "./TimesheetTradieWeekBlock.vue?vue&type=script&lang=js"
export * from "./TimesheetTradieWeekBlock.vue?vue&type=script&lang=js"
import style0 from "./TimesheetTradieWeekBlock.vue?vue&type=style&index=0&id=52a2d194&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2d194",
  null
  
)

export default component.exports